export const DEFAULT_LOCALE = 'en-US';

export const LOCALES = [
  'en-US',
  'es-419',
  'fr-FR',
  'de-DE',
  'it-IT',
  'ja-JP',
  'pt-BR',
  'ko-KR',
  'id-ID',
  'zh-CN',
  'th-TH',
  'vi-VN',
  'zh-Hant-TW'
] as const;

export type Locale = (typeof LOCALES)[number];

export const isValidLocale = (value: string | undefined | null): value is Locale =>
  !!value && (LOCALES as readonly string[]).includes(value);

export const hasLocalePrefix = (path: string | undefined | null): boolean => {
  if (!path || typeof path !== 'string') return false;
  const firstSegment = path.split('/').filter(Boolean)[0];
  return isValidLocale(firstSegment);
};

export const stripLocalePrefix = (path: string | undefined | null): string => {
  if (!path || typeof path !== 'string') return path ?? '';
  const segments = path.split('/');
  if (segments.length > 1 && isValidLocale(segments[1])) {
    const stripped = '/' + segments.slice(2).join('/');
    return stripped === '/' ? '/' : stripped.replace(/\/+$/, '') || '/';
  }
  return path;
};
